import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./homepage.${locale}.json`));
